import React, { useState, useCallback, useEffect } from 'react';
import { useJsApiLoader, GoogleMap, Marker } from '@react-google-maps/api';

const containerStyle = {
  width: '90%',
  height: '90%'
};

const center = {
  lat: 6.28707348641597,
  lng: -75.56441317444299
};

interface MapProps {
  origin: { lat: number, lng: number } | null;
  destination: { lat: number, lng: number } | null;
  
}

const Map: React.FC<MapProps> = ({ origin, destination }) => {

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? ''
  });

  console.log(origin, destination)

  const [map, setMap] = useState<google.maps.Map | null>(null);

  const onLoad = useCallback(function callback(map: google.maps.Map) {
    setMap(map);
  }, []);

  const onUnmount = useCallback(function callback(map: google.maps.Map) {
    setMap(null)
  }, [])

  // useEffect para centrar el mapa cuando cambian las coordenadas
  useEffect(() => {
    if (origin && destination && map) {
      const bounds = new google.maps.LatLngBounds();
      bounds.extend(origin);
      bounds.extend(destination);
      map.fitBounds(bounds);
    } else if (origin && map) {
      map.setCenter(origin);
    }
  }, [origin, destination, map]);

  return  isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={10}
      onLoad={onLoad}
      onUnmount={onUnmount}
    >
      {origin && <Marker position={origin} />}
      {destination && <Marker position={destination} />}
    </GoogleMap>
  ) : <></>;
}

export default React.memo(Map);